import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useNavigate, useParams, useLocation } from "react-router-dom";

import TopButton from "components/topbutton/TopButton";
import * as EgovNet from 'api/fetch';

import ReactQuill from "react-quill-new";

import "styles/scss/NnewDetail.scss";

import noImage from "images/business/noImage-text.jpg";

const BusinessDetail = () => {
    const navigate = useNavigate();
    const [business, setBusiness] = useState([]);
    const [html, setHtml] = useState([]);

    const location = useLocation(); // useLocation 훅을 사용하여 현재 위치 정보 가져오기

    //목록 버튼 이동
    const handleButtonClick = () => {
        navigate('/business');
    };

    const [isCompanyDropdownOpen, setIsCompanyDropdownOpen] = useState(false);
    const { id } = useParams(); // URL 파라미터로 ID 가져오기

    useEffect(() => {
        retrieveList();
    }, []);

    const retrieveList = () => {
        const retrieveDetailURL = `/api/pst/${id}`;
        const requestOptions = {
            method: "GET",
            headers: {
                'Content-type': 'application/json',
            }
        }
        EgovNet.requestFetch(retrieveDetailURL,
            requestOptions,
            function (resp) {
                setBusiness(resp.result.pst);
                // 이미지 태그가 포함이 되어 있지 않을때 지정된 이미지 태그 추가
                if (!resp.result.pst.pstCn.includes('<img')) {
                    const imgTag = `<img src="${noImage}" alt="No Image" />`;
                    setHtml(imgTag + resp.result.pst.pstCn); // content 상태를 업데이트합니다.
                } else {
                    setHtml(resp.result.pst.pstCn); // content 상태를 업데이트합니다.
                }
            },
            (resp) => {
                console.log("err response : ", resp);
            }
        );
    };    

    const viewModeModules = {
        toolbar: false,
    };

    // 날짜 연월일 시:분 형식으로 변경하는 함수
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        return `${year}-${month}-${day} ${hours}:${minutes}`;
    };

    const stripHtmlTags = (html) => {
        if (!html) return ''; // null 또는 undefined 처리
        
        return html
        .replace(/<\/p>/gi, '\n') // </p> 태그를 줄바꿈으로 대체
        .replace(/<p[^>]*>/gi, '') // <p> 태그 제거
        .replace(/<br\s*\/?>/gi, '\n') // <br> 태그를 줄바꿈으로 대체
        .replace(/<\/?[^>]+(>|$)/g, '') // 나머지 태그 제거
        .replace(/\n\s*\n/g, '\n') // 연속된 줄바꿈을 하나로 축소
        .trim(); // 앞뒤 공백 제거
    };
    
    return (
        <>
        <div className="news-background">
        <TopButton />
            <h1>비지니스</h1>
            {/* 브레드크럼 */}
            <div className="breadcrumb-box container">
            <nav className="breadcrumb">
                <ul>
                    <li className="home-icon">
                    <Link to="/">
                        <span className="home"></span>
                    </Link>
                    </li>
                    <li className="dropdown" onClick={() => setIsCompanyDropdownOpen(!isCompanyDropdownOpen)}>
                        비지니스
                        <span className="dropdown-icon">
                        {isCompanyDropdownOpen ? "▲" : "▼"}
                        </span>
                        {isCompanyDropdownOpen && (
                            <ul className="dropdown-menu">
                                <li>
                                    <Link to="/about">회사소개</Link>
                                </li>
                                <li>
                                    <Link to="/business">비즈니스</Link>
                                </li>
                                <li>
                                    <Link to="/news">N소식</Link>
                                </li>
                                <li>
                                    <Link to="/recruitment">인재채용</Link>
                                </li>
                            </ul>
                        )}
                    </li>
                </ul>
            </nav>

            <div className="mobile">
                <ul>
                    <li className="home-icon">
                        <Link to="/">
                            <span className="home"></span>
                        </Link>
                    </li>
                    <li className="dropdown" onClick={() => setIsCompanyDropdownOpen(!isCompanyDropdownOpen)}>
                        비지니스
                        <span className="dropdown-icon">
                        {isCompanyDropdownOpen ? "▲" : "▼"}
                        </span>
                        {isCompanyDropdownOpen && (
                        <ul className="dropdown-menu">
                            <li>
                                <Link to="/about">회사소개</Link>
                            </li>
                            <li>
                                <Link to="/business">비즈니스</Link>
                            </li>
                            <li>
                                <Link to="/news">N소식</Link>
                            </li>
                            <li>
                                <Link to="/recruitment">인재채용</Link>
                            </li>
                        </ul>
                        )}
                    </li>
                </ul>
            </div>
            </div>
        </div>


    {/* N소식 상세보기 콘텐츠 */}
    <div className="container newDetail-box">
      <ul>
        <li className='tit'>
          <h3 className="sub-tit">{business.pstTtl}</h3>
          <div className="day-box">
            <span>{formatDate(business.regDt)}</span>
          </div>
            <p className="swiper-p"
                dangerouslySetInnerHTML={{
                    __html: stripHtmlTags(business.bizNm).replace(/\n/g, '<br />'),
                }}
            ></p>
        </li>
        <div className="newDetail-img">
            <ReactQuill
                modules={viewModeModules}
                value={html || ''}
            />
        </div>
        <li>
            <div>
                <button type="button" className="btn btn-list" onClick={handleButtonClick}>돌아가기</button>
            </div>
        </li>
      </ul>
    </div>

        </>
    );
}

export default BusinessDetail;